import axiosInstance from '@/api';
import { IUsersData } from '@/entities/admin-app/users';
import { userApiArea } from '@/services/api/userApiArea';
import { UserTariffParams } from '@/entities/admin-app/user';
import { IFilialsInitialFilters } from '@/types/enums/filials';
import { IQueryTableV1, ISimpleFiltersQuery } from '@/types/api';
import { HomeFactoryServiceType } from '@/services/factories/homeFactory/interface';

/** Класс фабрика HomeFactoryService который хранит в себе методы для работы с DASHBOARD виджетами **/
export class HomeFactoryService implements HomeFactoryServiceType {
  LoadDashboardWidgets = async (id: number, paymentsDate: string | null) => {
    const results = await Promise.all([
      this.LoadUsersSection(id),
      this.LoadMailSection(id),
      this.LoadRoleSection({
        Count: 10,
        Offset: 0,
        Query: '',
        FilterConditions: []
      }),
      this.LoadPaymentSection({ id: id ?? 0, paymentsDate: paymentsDate }),
      this.LoadServicesSection(id),
      this.LoadDiskSpaceSection(id),
      this.LoadFilialSection({
        Count: 10,
        Offset: 0,
        Query: '',
        SkipCustomers: []
      })
    ]);

    return {
      usersWidget: results[0],
      mailWidget: results[1],
      roleWidget: results[2],
      paymentWidget: results[3],
      servicesWidget: results[4],
      diskSpaceWidget: results[5],
      filialWidget: results[6]
    };
  };
  LoadUsersSection = async (id: number): Promise<IUsersData> => {
    try {
      return await userApiArea().LoadUsersForWidgetSection(id);
    } catch (e) {
      throw new Error(`Error in LoadUsersSection: ${e}`);
    }
  };
  LoadMailSection = async (id: number): Promise<any> => {
    // TODO вынести в отдельный api сервис и типизировать правильно
    try {
      const { data } = await axiosInstance.get('v1/EmailServer', {
        params: { customerId: id }
      });
      return data;
    } catch (e) {
      throw new Error(`Error in LoadMailSection: ${e}`);
    }
  };
  LoadRoleSection = async (params: ISimpleFiltersQuery): Promise<any> => {
    // TODO вынести в отдельный api сервис и типизировать правильно
    try {
      const response = await axiosInstance.post('v2/roles/list', {
        Count: params.Count || 10,
        Offset: params.Offset || 0,
        Query: params.Query || '',
        FilterConditions: params.FilterConditions || []
      });
      return response.data.Response.Data;
    } catch (e) {
      throw new Error(`Error in LoadRoleSection: ${e}`);
    }
  };
  LoadPaymentSection = async (params: UserTariffParams): Promise<any> => {
    // TODO вынести в отдельный api сервис и типизировать правильно И ПРОВЕРИТЬ НА SAAS
    const { id, paymentsDate } = params;

    try {
      const { data } = await axiosInstance.get(`Tariff/getUserTariff`, {
        params: { userId: id, timeStamp: paymentsDate },
        headers: paymentsDate ? { 'Cache-Control': 'no-cache' } : { 'Cache-Control': 'default' }
      });
      return data;
    } catch (e) {
      throw new Error(`Error in LoadPaymentSection: ${e}`);
    }
  };
  LoadServicesSection = async (id: number): Promise<any> => {
    // TODO вынести в отдельный api сервис и типизировать правильно
    try {
      const response = await axiosInstance.get(`v1/serviceshealth`, {
        params: { customerId: id }
      });
      return response.data.Services;
    } catch (e) {
      throw new Error(`Error in LoadServicesSection: ${e}`);
    }
  };
  LoadDiskSpaceSection = async (id: number): Promise<any> => {
    // TODO вынести в отдельный api сервис и типизировать правильно

    try {
      const response = await axiosInstance.get('v2/customer/quota', {
        params: { id }
      });

      return response.data.Response.Data;
    } catch (e) {
      throw new Error(`Error in GetFilialQuota: ${e}`);
    }
  };
  LoadFilialSection = async (payload?: IQueryTableV1<IFilialsInitialFilters>): Promise<any> => {
    // TODO вынести в отдельный api сервис и типизировать правильно

    try {
      const response = await axiosInstance.post('/v2/customer/list', {
        ...payload
      });

      return response.data.Response.Data;
    } catch (e) {
      throw new Error(`Error in GetFilials: ${e}`);
    }
  };
}
